module.exports = __webpack_public_path__ + "static/social-f399d4eef33b020d6644ac61639c9af2.png";